import { Component, OnInit } from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {AuthService} from '../../../services/auth.service';
import {MatDialog} from '@angular/material/dialog';
import {ErrorDialogComponent} from '../../user-actions/error-dialog/error-dialog.component';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-password-change-confirm',
  templateUrl: './password-change-confirm.component.html',
  styleUrls: ['./password-change-confirm.component.css']
})
export class PasswordChangeConfirmComponent implements OnInit {

  passwordChangeForm: FormGroup;
  notFocused = false;
  submitted: boolean;
  show = false;
  uuid: string;
  title = 'IBD Tool';
  hide = true;
  hideConfirm = true;

  constructor(private authService: AuthService,
              private router: Router,
              private route: ActivatedRoute,
              public dialog: MatDialog) {
    this.route.params.subscribe(params => {
      this.uuid = params.uuid;
    });
  }

  ngOnInit(): void {
    this.passwordChangeForm = new FormGroup({
      newPassword: new FormControl('', [Validators.required, this.validatePassword()]),
      confirmNewPassword: new FormControl('', [Validators.required])
    });
  }

  onSubmit(form) {
    this.submitted = true;
    this.show = true;
    console.log(form);
    const f = form;

    if (f.newPassword !== f.confirmNewPassword) {
      const msg = 'I campi \'Nuova password\' e \'Conferma nuova password\' non coincidono!';
      this.openDialog(msg);
    } else {

      this.authService.changePassword(f, this.uuid)
        .subscribe(d => {
            console.log(d.status);
            if (d.status === 200) {
              this.router.navigateByUrl('/success').then(() => setTimeout(() => location.replace('/startup'), 1500));
            }
          },
          error => {
            console.log(error);
            var msg = 'C\'è stato un errore. Riprovi più tardi e se il problema persiste contattaci via e-mail';
            if (error.status === 400) {
              //msg = 'La password che ha inserito non rispetta i requisiti, provi a controllare che rispetti tutti i punti e che le due password coincidano. Se il problema dovesse persistere ci contatti al nostro indirizzo e-mail.';
              msg = 'La password che ha inserito non è lunga almeno 8 caratteri. Se il problema dovesse persistere ci contatti al nostro indirizzo e-mail.';
            }
            if (error.status === 408) {
              msg = 'Il link presente nella e-mail che ha ricevuto è scaduto (aveva un giorno di validità). Richiedere un nuovo link cliccando nella pagina principale sulla voce \"Non ricordi come accedere\"';
            }
            if (error.status === 409) {
              // al momento il server non rilancia questo errore.
              msg = 'La password inserita è uguale alla precedente, inserirne una nuova.';
            }
            this.openDialog(msg);
          });
    }
  }

  openDialog(message: string): void {
    this.show = true;
    this.submitted = true;
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      this.show = false;
      console.log('Finestra chiusa');
      this.submitted = false;
    });
  }

  validatePassword(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const p = control.value;
      /* Scommentare se si vuole che la password rispetti i seguenti requisiti
      if (p.search(/[a-z]/) < 0) {
        return {lowerError: 'La password deve contenere almeno un carattere minuscolo'};
      }
      if (p.search(/[A-Z]/) < 0) {
        return {upperError: 'La password deve contenere almeno un carattere maiuscolo'};
      }
      if (p.search(/[0-9]/) < 0) {
        return {digitError: 'La password deve contenere almeno un numero'};
      }
      const format = /[!#$%&*()+,\-./:\\;<=>?\[@\]^_£]+/;
      if (!format.test(p)) {
        return {specialError: 'La password deve contenere almeno un carattere speciale tra quelli sopra elencati'};
      }
      */
      if (p.length < 8) {
        return {minLengthError: 'La password deve contenere almeno 8 caratteri'};
      }
      return null;
    };
  }

  getErrorMessage() {
    /* Scommentare se si vuole che la password rispetti i seguenti requisiti
    if (this.passwordChangeForm.get('newPassword').hasError('lowerError')) {
      return 'La password deve contenere almeno un carattere minuscolo';
    }
    if (this.passwordChangeForm.get('newPassword').hasError('upperError')) {
      return 'La password deve contenere almeno un carattere maiuscolo';
    }
    if (this.passwordChangeForm.get('newPassword').hasError('digitError')) {
      return 'La password deve contenere almeno un numero';
    }
    if (this.passwordChangeForm.get('newPassword').hasError('specialError')) {
      return 'La password deve contenere almeno un carattere speciale tra quelli sopra elencati';
    }
    */
    if (this.passwordChangeForm.get('newPassword').hasError('minLengthError')) {
      return 'La password deve essere lunga almeno 8 caratteri';
    }
  }

}
